module.exports = __webpack_public_path__ + "img/gamebg.4c1e5558.png";